import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=83bf3bce&scoped=true"
import script from "./Transfer.vue?vue&type=script&lang=js"
export * from "./Transfer.vue?vue&type=script&lang=js"
import style0 from "./Transfer.vue?vue&type=style&index=0&id=83bf3bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bf3bce",
  null
  
)

export default component.exports